import { Component } from "@angular/core";
import { CdiListingComponent } from "./cdi-listing/cdi-listing.component";

@Component({
  selector: "jni-cdi",
  templateUrl: "./cdi.component.html",
  styleUrls: ["./cdi.component.scss"],
  imports: [CdiListingComponent],
})
export class CdiComponent {}
